import Color from "color";

export default function useAutoIterations({
  backgroundColor,
  primaryColor,
  secondaryColor
}: {
  backgroundColor: string;
  primaryColor?: string;
  secondaryColor?: string;
}) {
  const backgroundColorAsColor = Color(backgroundColor);
  const primaryColorAsColor = Color(primaryColor);
  const secondaryColorAsColor = Color(secondaryColor);

  const hoverChange = 0.1;
  const activeChange = 0.2;
  const selectedChange = 0.3;

  const blackHover = Color("#000")
    .lightness(10)
    .hex();

  const blackActive = Color("#000")
    .lightness(20)
    .hex();

  const blackSelected = Color("#000")
    .lightness(30)
    .hex();
  // TODO refactor implementation
  const autoInteractionsStyles = {
    hover: {
      backgroundColor: "",
      primaryColor: "",
      secondaryColor: ""
    },
    active: {
      backgroundColor: "",
      primaryColor: "",
      secondaryColor: ""
    },
    selected: {
      backgroundColor: "",
      primaryColor: "",
      secondaryColor: ""
    }
  };
  // TODO separated implementation for isLight
  // (set threshold that darker colors use darker selection)
  // https://github.com/Qix-/color/blob/4647eae1fa2c484df2d38713de03375235b3fb01/index.js#L284
  if (backgroundColorAsColor.isLight()) {
    autoInteractionsStyles.hover.backgroundColor = backgroundColorAsColor
      .darken(hoverChange)
      .hex();
    autoInteractionsStyles.active.backgroundColor = backgroundColorAsColor
      .darken(activeChange)
      .hex();
    autoInteractionsStyles.selected.backgroundColor = backgroundColorAsColor
      .darken(selectedChange)
      .hex();
  } else {
    if (backgroundColor === "#000" || backgroundColor === "#000000") {
      autoInteractionsStyles.hover.backgroundColor = blackHover;
      autoInteractionsStyles.active.backgroundColor = blackActive;
      autoInteractionsStyles.selected.backgroundColor = blackSelected;
    } else {
      autoInteractionsStyles.hover.backgroundColor = backgroundColorAsColor
        .lighten(hoverChange)
        .hex();
      autoInteractionsStyles.active.backgroundColor = backgroundColorAsColor
        .lighten(activeChange)
        .hex();
      autoInteractionsStyles.selected.backgroundColor = backgroundColorAsColor
        .darken(selectedChange)
        .hex();
    }
  }

  if (primaryColorAsColor.isLight()) {
    autoInteractionsStyles.hover.primaryColor = primaryColorAsColor
      .darken(hoverChange)
      .hex();
    autoInteractionsStyles.active.primaryColor = primaryColorAsColor
      .darken(activeChange)
      .hex();
    autoInteractionsStyles.selected.primaryColor = primaryColorAsColor
      .darken(selectedChange)
      .hex();
  } else {
    if (primaryColor === "#000" || primaryColor === "#000000") {
      autoInteractionsStyles.hover.primaryColor = blackHover;
      autoInteractionsStyles.active.primaryColor = blackActive;
      autoInteractionsStyles.selected.primaryColor = blackSelected;
    } else {
      autoInteractionsStyles.hover.primaryColor = primaryColorAsColor
        .lighten(hoverChange)
        .hex();
      autoInteractionsStyles.active.primaryColor = primaryColorAsColor
        .lighten(activeChange)
        .hex();
      autoInteractionsStyles.selected.primaryColor = primaryColorAsColor
        .darken(selectedChange)
        .hex();
    }
  }

  if (secondaryColorAsColor.isLight()) {
    autoInteractionsStyles.hover.secondaryColor = secondaryColorAsColor
      .darken(hoverChange)
      .hex();
    autoInteractionsStyles.active.secondaryColor = secondaryColorAsColor
      .darken(activeChange)
      .hex();
    autoInteractionsStyles.selected.secondaryColor = secondaryColorAsColor
      .darken(selectedChange)
      .hex();
  } else {
    if (secondaryColor === "#000" || secondaryColor === "#000000") {
      autoInteractionsStyles.hover.secondaryColor = blackHover;
      autoInteractionsStyles.active.secondaryColor = blackActive;
      autoInteractionsStyles.selected.secondaryColor = blackSelected;
    } else {
      autoInteractionsStyles.hover.secondaryColor = secondaryColorAsColor
        .lighten(hoverChange)
        .hex();
      autoInteractionsStyles.active.secondaryColor = secondaryColorAsColor
        .lighten(activeChange)
        .hex();
      autoInteractionsStyles.active.secondaryColor = secondaryColorAsColor
        .darken(selectedChange)
        .hex();
    }
  }

  return autoInteractionsStyles;
}
